import _CardActions from "@mui/material/CardActions";
import _CardContent from "@mui/material/CardContent";
import _Card from "@mui/material/Card";
import _Tooltip from "@mui/material/Tooltip";
import _IconButton from "@mui/material/IconButton";
import _Close from "@mui/icons-material/Close";
import _Typography from "@mui/material/Typography";
import _Box from "@mui/material/Box";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Trans } from 'react-i18next';
import { styled } from 'styled-components';
export function InfoCard({
  error,
  Icon,
  iconBackground,
  iconProps,
  description,
  descriptionProps,
  actions,
  onClose,
  ...props
}) {
  return /*#__PURE__*/React.createElement(_Card, props, /*#__PURE__*/React.createElement(StyledCardContent, null, iconBackground ? /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    borderRadius: 4,
    display: "flex",
    height: 32,
    justifyContent: "center",
    sx: {
      backgroundColor: '#fff'
    },
    width: 32
  }, /*#__PURE__*/React.createElement(Icon, _extends({
    color: error ? 'error' : 'primary'
  }, iconProps))) : /*#__PURE__*/React.createElement(Icon, _extends({
    color: error ? 'error' : 'primary'
  }, iconProps)), /*#__PURE__*/React.createElement(_Typography, _extends({
    alignSelf: "center",
    color: "textSecondary",
    variant: "caption"
  }, descriptionProps), description), onClose && /*#__PURE__*/React.createElement(_Tooltip, {
    placement: "left",
    title: /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "commons.actions.close"
    })
  }, /*#__PURE__*/React.createElement(_IconButton, {
    onClick: onClose,
    size: "small"
  }, /*#__PURE__*/React.createElement(_Close, null)))), actions && /*#__PURE__*/React.createElement(StyledCardActions, null, actions));
}
const StyledCardContent = styled(_CardContent)`
  align-items: flex-start;
  display: flex;

  &&& {
    padding-bottom: 16px;
  }

  > *:not(:first-child) {
    margin-left: 16px;
  }

  svg {
    flex-shrink: 0;
  }

  button {
    flex-shrink: 0;
  }
`;
const StyledCardActions = styled(_CardActions)`
  padding: 8px 16px;

  > *:not(:first-child) {
    margin-left: 16px;
  }
`;